const yitNewsFeature = {
    id: "yit-corporation-news",
    name: "feature.yit-corporation-news.name",
    iconClass: "fal fa-newspaper",
    globalSettings: {},
    schema: {}
};

export { yitNewsFeature };